export * from '../src/composites/wui-logo/index.js';
//# sourceMappingURL=wui-logo.js.map